import { lazy } from 'react'

export const GeneralInfoLazy = lazy(() => import('./GeneralInfo'))
